/**
 * Find the plan group by the group name given
 *
 * @param {Array<object>} planGroup
 * @param {string} groupName
 */
const findPlanGroupByName = (planGroup, groupName) =>
  planGroup.find(group => group.groupName === groupName);

export default findPlanGroupByName;
